"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var MediaLibraryEditableName_1 = __importDefault(require("./MediaLibraryEditableName"));
var formatMimeType = function (mimeType) {
    return mimeType.split("/").pop();
};
var getFileExtension = function (fileName) {
    if (!fileName) {
        return "";
    }
    var parts = fileName.split(".");
    return parts.length > 1 ? parts.pop() : "";
};
var Thumbnail = (0, react_1.forwardRef)(function (_a, ref) {
    var item = _a.item, isFolder = _a.isFolder, draggingItemCount = _a.draggingItemCount, draggedItemId = _a.draggedItemId, isDragging = _a.isDragging, permissions = _a.permissions, selectedFolderIds = _a.selectedFolderIds, handleChangeFolderName = _a.handleChangeFolderName, folderPermissions = _a.folderPermissions;
    var divRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, function () { return divRef.current; });
    var _b = (0, react_1.useState)(false), editMode = _b[0], setEditMode = _b[1];
    var fileType = isFolder ? "" : (getFileExtension(item.file_name) || formatMimeType(item.mime_type || ""));
    var displayFileName = isFolder ? item.name : "".concat(item.name, ".").concat(fileType);
    var isCurrentlyDragged = isDragging || draggedItemId === item.id;
    var isSelected = selectedFolderIds.includes(item.id);
    var handleSave = function (folderId, newName) {
        if (isFolder) {
            handleChangeFolderName(item.id, newName);
        }
    };
    var handleNameClick = function (e) {
        if (isFolder && isSelected) {
            e.stopPropagation();
            e.preventDefault();
            setEditMode(!editMode);
        }
    };
    return (react_1.default.createElement("div", { key: item.id, className: MediaLibrary_module_css_1.default["thumbnail-container"], ref: divRef, style: { opacity: isCurrentlyDragged ? 0.5 : 1 } },
        isFolder ? (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: MediaLibrary_module_css_1.default["folder-icon"], icon: free_solid_svg_icons_1.faFolder, title: item.name, style: { opacity: isCurrentlyDragged ? 0.5 : 1 } })) : (item.thumbnailUrl ? (react_1.default.createElement("img", { src: item.thumbnailUrl, alt: item.file_name, title: item.file_name, className: MediaLibrary_module_css_1.default["thumbnail-image"], style: { opacity: isCurrentlyDragged ? 0.5 : 1 } })) : (react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default["file-placeholder"], title: item.file_name },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFile, className: MediaLibrary_module_css_1.default["file-icon"], style: { opacity: isCurrentlyDragged ? 0.5 : 1 } })))),
        react_1.default.createElement("div", { className: "".concat(MediaLibrary_module_css_1.default["thumbnail-text"], " ns-font-family"), title: item.file_name, onClick: handleNameClick }, isFolder && isSelected && editMode ? (react_1.default.createElement(MediaLibraryEditableName_1.default, { id: item.id, name: item.name, permissions: permissions, onSave: handleSave, style: { fontSize: "12px", width: "65px" }, folderPermissions: folderPermissions, viewMode: "grid" })) : (displayFileName)),
        draggingItemCount > 1 && draggedItemId === item.id && (react_1.default.createElement("div", { className: MediaLibrary_module_css_1.default["dragging-counter"] }, draggingItemCount))));
});
Thumbnail.displayName = "Thumbnail";
exports.default = Thumbnail;
